import React from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import _ from "lodash";
import { useQuery } from "@apollo/client";
import { Grid, Typography } from "@mui/material";
import Loader from "ui/components/Loader";
import ParcelInfoTableInner from "ui/components/ParcelInfoTable/ParcelInfoTableInner";
import CurrentUnderwriterParcelComparablesQuery from "ui/sites/underwriting/queries/CurrentUnderwriterParcelComparablesQuery.graphql";

const PREFIX = 'UnderwritingParcelComparablesContainer';

const classes = {
  settings: `${PREFIX}-settings`,
  table: `${PREFIX}-table`,
  header: `${PREFIX}-header`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.settings}`]: {
    paddingRight: 10,
    paddingTop: 10
  },
  [`& .${classes.table}`]: {
    minWidth: 350
  },
  [`& .${classes.header}`]: {
    marginBottom: 10
  }
});

function UnderwritingParcelComparablesContainer({ parcel, compType }) {

  const { data, loading } = useQuery(CurrentUnderwriterParcelComparablesQuery, {
    variables: {
      parcelId: parcel.id,
      compType
    }
  });

  return (
    <Root>
      <Grid size={12}>
        <Typography align="center" variant="h4" className={classes.header}>
          Comparables
        </Typography>
        {loading && <Loader />}
        {!loading && (
          <ParcelInfoTableInner
            parcels={_.map(
              _.get(
                data,
                "currentUnderwriter.parcel.currentRequest.comparables.edges",
                []
              ),
              "node.parcel"
            )}
            openInNewTab
          />
        )}
      </Grid>
    </Root>
  );
}

UnderwritingParcelComparablesContainer.propTypes = {
  parcel: PropTypes.object,
  compType: PropTypes.string
};

export default UnderwritingParcelComparablesContainer;
